import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=51dd27ae"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports